<template>
    <div class="pp-checkbox-group" :class="{'is-inline': inline}">
        <div class="pp-radio__all">
            <pp-checkbox v-if="showChooseAll" v-model="isChecked"
                :icon="icon" :activeIcon="indeterminate.icon" 
                :color="color" :disabled="disabled" :size="currentSize"
                label="全选"
                @change="indeterminateChange">
            </pp-checkbox>
        </div>
        <div class="pp-radio__content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
/**
 * 多选组
 * @param {array} value 单组件使用 v-model绑定值 返回一个Boolean，true选中，false未选中
 * @param {[string, number]} label 选中值 pp-checkbox-group使用
 * @param {boolean} disabled 禁用状态
 * @param {string} color 选中颜色
 * @param {string} size 尺寸 [normal默认, small, mini]
 * @param {string} icon 未选中时图标
 * @param {string} activeIcon 选中时图标
 * @param {boolean} showChooseAll 显示全选按钮 default:true
 * @param {string} indeterminateIcon 全选按钮的不确定状态按钮
 * @param {boolean} inline 行内展示选择项
 * @param {number} length 最多选择数
 * @param {string} align 按钮对齐方式 ['right']
 */
export default {
    name: 'pp-checkbox-group',
    provide: function() {
        return {
            CheckboxGroup: this,
        };
    },
    inject: {
        Form: {
            default: ''
        },
        FormItem: {
            default: ''
        },
        CheckboxGroup: {
            default: ''
        },
    },
    props: {
        value: Array,
        disabled: Boolean,
        size: String,
        color: String,
        icon: {
            type: String,
            default: 'pp-icon-checkbox-unchecked',
        },
        activeIcon: {
            type: String,
            default: 'pp-icon-checkbox-checked',
        },
        showChooseAll:{ 
            type: Boolean,
            default: true,
        },
        indeterminateIcon: {
            type: String,
            default: 'pp-icon-checkbox-indeterminate',
        },
        inline: Boolean,
        length: Number,
        align: {
            type: String,
            validator: function(value) {
                return ['right'].includes(value);
            },
        },
    },
    data: function() {
        return {
            childrenValue: [],
            isChecked: false,
        };
    },
    computed: {
        currentSize: function() {
            return this.Form.size 
                || this.FormItem.size 
                || this.size;
        },
        currentLength: function() {
            return this.length || this.childrenValue.length;
        },
        currentDisabled: function() {
            return this.Form.disabled || this.disabled;
        },
        indeterminate: function() {
            if(this.value.length === this.childrenValue.length) {
                return {
                    checked: true,
                    icon: this.activeIcon
                };
            }
            else if(this.value.length) {
                return {
                    checked: true,
                    icon: this.indeterminateIcon
                };
            }
            else {
                return {
                    checked: false,
                    icon: this.icon
                };
            }
        },
    },
    watch: {
        indeterminate: {
            deep: true,
            handler: function(n, o) {
                this.isChecked = n.checked
            }
        },
    },
    methods: {
        update: function(val) {
            let value = this.value.concat();
            let index = value.findIndex(v=> v === val);

            if(index === -1) {
                //hack 全选会与currentLength有冲突
                value.length < this.currentLength && value.push(val) 
            }
            else {
                value.splice(index, 1)
            }
            this.emits(value)
        },
        emits: function(val) {
            this.$emit('input', val)
            this.$emit('change', val)
        },
        checkAll: function() {
            this.emits(this.childrenValue)
        },
        uncheckAll: function() {
            this.emits([])
        },
        indeterminateChange: function(val) {
            val ? this.checkAll() : this.uncheckAll()
        },
    },
}
</script>
